export default [
	'bedc:wholehouse:debug',

	//
	'bedc:wholehouse:read:{organizationId}',

	// usage
	'bedc:wholehouse:usage:lookup',
	'bedc:wholehouse:create:{organizationId}/usage',
	'bedc:wholehouse:read:{organizationId}/usage',
	'bedc:wholehouse:update:{organizationId}/usage',
	'bedc:wholehouse:delete:{organizationId}/usage',

	// image
	'bedc:wholehouse:image:lookup',

	// recipe
	'bedc:wholehouse:recipe:lookup',
	'bedc:wholehouse:create:{organizationId}/recipe',
	'bedc:wholehouse:read:{organizationId}/recipe',
	'bedc:wholehouse:update:{organizationId}/recipe',
	'bedc:wholehouse:delete:{organizationId}/recipe',

	// recipe copy
	'bedc:wholehouse:create:{organizationId}/recipe-copy',

	//material
	'bedc:wholehouse:material:lookup',
	'bedc:wholehouse:create:{organizationId}/material',
	'bedc:wholehouse:read:{organizationId}/material',
	'bedc:wholehouse:update:{organizationId}/material',
	'bedc:wholehouse:delete:{organizationId}/material',

	//material template
	'bedc:wholehouse:material-template:lookup',
	'bedc:wholehouse:create:{organizationId}/material-template',
	'bedc:wholehouse:read:{organizationId}/material-template',
	'bedc:wholehouse:update:{organizationId}/material-template',
	'bedc:wholehouse:delete:{organizationId}/material-template',

	//formula
	'bedc:wholehouse:formula:lookup',
	'bedc:wholehouse:create:{organizationId}/formula',
	'bedc:wholehouse:read:{organizationId}/formula',
	'bedc:wholehouse:update:{organizationId}/formula',
	'bedc:wholehouse:delete:{organizationId}/formula',

	//parameter
	'bedc:wholehouse:parameter:lookup',
	'bedc:wholehouse:create:{organizationId}/parameter',
	'bedc:wholehouse:read:{organizationId}/parameter',
	'bedc:wholehouse:update:{organizationId}/parameter',
	'bedc:wholehouse:delete:{organizationId}/parameter',
] as const;
